import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';



@Injectable({
    providedIn: 'root'
})
export class GoogleApiService {

    private readonly DRIVE_API_URL = 'https://www.googleapis.com/drive/v3';
    private readonly SCRIPT_API_URL = 'https://script.googleapis.com/v1/scripts';

    constructor(
        private http: HttpClient,
        private authService: AuthService
    ) {
    }

    runScript(scriptId: string, functionName: string, parameters: any[]): Observable<any> {
        const url = `${this.SCRIPT_API_URL}/${scriptId}:run`;
        const body = {
            function: functionName,
            parameters: parameters,
            devMode: true
        };
        return this.http.post(url, body);
    }

    getDriveFile(fileId: string, fields = '*'): Observable<any> {
        const url = `${this.DRIVE_API_URL}/files/${fileId}?supportsTeamDrives=true&fields=${fields}`;
        return this.http.get(url);
    }

    listDriveFiles(query: string, fields = '*'): Observable<any> {
        const url = `${this.DRIVE_API_URL}/files?supportsTeamDrives=true&includeTeamDriveItems=true&q=${encodeURIComponent(query)}&fields=${fields}`;
        return this.http.get(url);
    }
}
